<template>
  <div class="headerholder">
    <div class="itemsheader" style="position:relative;">
      <div class="item teklistnaam" style="opacity: 1;min-width: 180px;">
        <span class="tekst">Naam</span>
      </div>
      <div class="item teklistemail" style="min-width:300px;">
        <span class="tekst">Email</span>
      </div>
      <div class="item teklisttelefoonnummer" style="max-width:140px;">
        <span class="tekst">Telefoon</span>
      </div>
      <div class="item teklistdisciplines" style="opacity: 1;max-width:140px;">
        <span class="tekst">Disciplines</span>
      </div>
      <div class="item teklistbedrijfsnaam">
        <span class="tekst">Bedrijfsnaam</span>
      </div>
      <div class="item teklistwoonplaats">
        <span class="tekst">Woonplaats</span>
      </div>
      <div class="item teklisttekenprogramma" style="min-width: 260px;max-width: 260px;">
        <span class="tekst">Tekenprogramma</span>
      </div>
      <div class="item teklistaantalopdrachten" style="min-width:30px;width:30px;max-width:30px;">
        <!-- HIER MOET DE SORTEER BOVEN / BENEDEN ARROW -->
        <!-- <span class="discipline-orange">{{opdrachtenVanTekenaar.length}}</span> -->
      </div>
    </div>

    <div class="filterbar" v-if="showTekFilters">
      <div class="item" style="opacity: 1;min-width: 180px;">
        <SearchfieldWithReset :filterOn="tekFilters.name" filterBy="name" />
      </div>
      <div class="item" style="min-width:300px;">
        <SearchfieldWithReset :filterOn="tekFilters.email" filterBy="email" />
      </div>
      <div class="item" style="max-width:140px;">
        <SearchfieldWithReset :filterOn="tekFilters.telefoonnummer" filterBy="telefoonnummer" />
      </div>
      <div class="item" style="opacity: 1;max-width:140px;">
        <DropdownSelect3
          :class="{
            pastel0: tekFilters.disciplines == '',
            pastel1: tekFilters.disciplines == 'Bouwkunde',
            pastel2: tekFilters.disciplines == 'Werktuigbouwkunde',
            pastel3: tekFilters.disciplines == 'Installatietechniek',
            pastel4: tekFilters.disciplines == 'Elektrotechniek',
            pastel5: tekFilters.disciplines == 'Huisvesting',
            pastel6: tekFilters.disciplines == 'Plattegronden',
            pastel7: tekFilters.disciplines == 'Concepten - 3D Print',
            pastel8: tekFilters.disciplines == 'Brandpreventie',
            pastel9: tekFilters.disciplines == 'Nen2580'
          }"
          :filterOn="tekFilters.disciplines"
          filterBy="disciplines"
        />
      </div>
      <div class="item">
        <SearchfieldWithReset :filterOn="tekFilters.bedrijfsnaam" filterBy="bedrijfsnaam" />
      </div>
      <div class="item">
        <SearchfieldWithReset :filterOn="tekFilters.woonplaats" filterBy="woonplaats" />
      </div>
      <div class="item" style="min-width: 260px;max-width: 260px;">
        <SearchfieldWithReset :filterOn="tekFilters.tekenprogramma" filterBy="tekenprogramma" />
      </div>
      <div class="item" style="min-width:30px;width:30px;max-width:30px;">
        <!-- HIER MOET DE SORTEER BOVEN / BENEDEN ARROW -->
        <!-- <span class="discipline-orange">{{opdrachtenVanTekenaar.length}}</span> -->
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../../store';
import SearchfieldWithReset from './SearchfieldWithReset';
import DropdownSelect3 from './DropdownSelect3';

export default {
  name: 'ItemsHeader',
  components: {
    SearchfieldWithReset,
    DropdownSelect3
  },
  computed: {
    showTekFilters() {
      return store.state.showTekFilters;
    },
    tekFilters() {
      return store.state.tekFilters;
    }
  }
};
</script>

<style scoped>
.headerholder {
  position: sticky;
  top: 100px;
  z-index: 2;
}
.itemsheader {
  /* border-top-left-radius: 5px;
    border-top-right-radius: 5px; */
  padding: 25px 25px;
  height: 60px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  background-color: #e4ecfa;
  border: 1px solid #c5d8e3;
}

.filterbar {
  padding: 0px 25px;
  padding-bottom: 15px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  background-color: #e4ecfa;
  margin-top: -1px;
  border-top: 1px solid #e4ecfa;
  border-bottom: 1px solid #c5d8e3;
  border-left: 1px solid #c5d8e3;
  border-right: 1px solid #c5d8e3;
}
.pastel0 {
  background-color: #bbb;
}
.item {
  opacity: 1;
  display: flex;
  overflow: hidden;
  align-items: center;
  min-width: 160px;
  width: 18%;
}

.tekst {
  white-space: nowrap;
  color: #0b1125;
}
</style>
